import {
  FluentProvider,
  Spinner,
  tokens,
  Toaster,
  useToastController,
} from "@fluentui/react-components";
import { Navigate, Route, Routes  } from "react-router-dom";
import {useGlobalStatus, GlobalStatusProvider} from '../../services/GlobalStatusProvider';
import { useTeams } from '@microsoft/teamsfx-react';
import {useState,useEffect}  from "react";
import {obtainAuthToken, GetA23ExternalApproval} from '../../services/apiService';
import {startOfMonth} from "date-fns";
import MonthlyTimesheetExternalApprovalStatus from "./MonthlyTimesheetExternalApprovalStatus";
import MonthlyTimesheetStatus from "./MonthlyTimesheetStatus";
import {jwtDecode} from 'jwt-decode';
import WeeklyTimesheetStatus from "./WeeklyTimesheetStatus";
import AdminHome from "./AdminHome";
import Sync from "./Sync";
import { TOASTER_ID } from "../../services/toastUtils";
import { showErrorToast } from "../../services/toastUtils";

export default function AdminApp() {
  const [approvalData, setApprovalData]= useState([]);
  const [loading, setLoading] = useState(false);
  const [currentMonthStart, setCurrentMonthStart] = useState(startOfMonth(Date()));
  const [isAdmin, setIsAdmin] = useState(false);
  const { dispatchToast } = useToastController(TOASTER_ID);

  // App initialisation
  useEffect(() => {
    const getA23ExternalApprovalData = async () => {
      setLoading(true);
      var token = await obtainAuthToken();

      // Check if user is allowed to use admin panel (part of security group)
      const decoded = jwtDecode(token);
      const groups = decoded.groups || [];

      const adminGroup = process.env.REACT_APP_ADMIN_GROUP;
      if (groups.includes(adminGroup)) {
        setIsAdmin(true);
        try {
          var approvalData = await GetA23ExternalApproval(currentMonthStart);
        } catch (error) {
          showErrorToast(dispatchToast, "Request timed out");
        }
        setApprovalData(approvalData);
      }
      setLoading(false);
    };

    getA23ExternalApprovalData();
  }, [currentMonthStart]);

  
  return (
    <>
    {isAdmin? (
        <GlobalStatusProvider loading={loading} setLoading={setLoading}>
          <Toaster toasterId={TOASTER_ID} />
          <AppContent approvalData={approvalData} setApprovalData={setApprovalData} currentMonthStart={currentMonthStart} setCurrentMonthStart={setCurrentMonthStart}/>
        </GlobalStatusProvider>
    ) : (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2 style={{ color: '#b00020' }}>Access Denied</h2>
        <p>You do not have permission to access this page.</p>
        <p>Please contact an administrator if you believe this is a mistake.</p>
      </div>
    )}
    </>
  );
}

function AppContent(props) {
  const [{theme}] = useTeams({});
  const{loading}= useGlobalStatus();
  
  return (
    <FluentProvider
    theme={theme}
    style={{ background: tokens.colorNeutralBackground3 }}>     
    <div style={{padding:20}}>
      {loading ? (
        <div style={{position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: '100vw',
          backgroundColor: theme.colorNeutralBackground1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: 0.85,
          zIndex: 9999,}}>
          <Spinner />
        </div>
        ) : (
          <></>
        )
      }
        <Routes>              
          <Route path="/" element={<AdminHome />} />
          <Route path="/monthlytimesheetapprover" element={<MonthlyTimesheetExternalApprovalStatus data={props.approvalData} setData={props.setApprovalData} currentMonthStart={props.currentMonthStart} setCurrentMonthStart={props.setCurrentMonthStart} />} />
          <Route path="/monthlytimesheet" element={<MonthlyTimesheetStatus data={props.approvalData} setData={props.setApprovalData} currentMonthStart={props.currentMonthStart} setCurrentMonthStart={props.setCurrentMonthStart} />} />
          <Route path="/weeklytimesheet" element={<WeeklyTimesheetStatus/>} />
          <Route path="/sync" element={<Sync/>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>      
    </div> 
  </FluentProvider>
  );
}

